import React, { useEffect, useState } from "react";
import axios from "axios";
import { LinkButton } from "../../globals/components/button";
import { EmileInfo } from "./styled_components/emile_info";
import { EmileDetailsContainer } from "./styled_components/your_emile";
import EggContainer from "./styled_components/egg_container";
import EmileStats from "./styled_components/emile_stats";
import EmilePetStatus from "./styled_components/emile_pet_status";

import woods from "./assets/woods.png";

import food from "./assets/food.png";
import heart from "./assets/heart.png";
import styled from "styled-components";
import background from "./assets/background.png";
import { Scale } from 'react-scaling';
import Tama1 from "./assets/Tama1.png";
import Tama2 from "./assets/Tama2.png";
import Tama3 from "./assets/Tama3.png";
import Tama4 from "./assets/Tama4.png";
import mergeImages from 'merge-images';

import useTamagotchis from "../games/hooks/useTamagotchis";
import usePupilStats from "../games/hooks/usePupilStats";

import ShopContainer from "./components/shop_container";
import ShopPopup from "./components/shop_popup";
import PurpleBar from "./components/purplebar_animated";
import Navbar from "./components/Navbar";

import { motion, AnimatePresence } from "framer-motion";

import useAuth from "../auth/hooks/useAuth";

import { ToastContainer, toast } from 'react-toastify';



export default function YourEmile(props) {


  const notify = () => toast("Bought Item");

  const { state: authState } = useAuth();
  const [tamagotchi, setTamagotchi] = useState(null);
  const [coins, setCoins] = useState(0);
  const [ownedItems, setOwnedItems] = useState(null);
  const [tamaImage, setTamaImage] = useState("");
  const [showShop, setShowShop] = useState(false);



  async function UpdateTamagotchi(equip){
    console.log(equip);
    let equippedItems = JSON.parse(tamagotchi.equipped_items);
    if (equippedItems == null || equippedItems == undefined){
        equippedItems = {};
        equippedItems.clothesId = "c0";
        equippedItems.hatId = "h0";
        equippedItems.accessoriesId = "a0";
    }
    //get the type by the first letter
    if (equip[0] == "h"){
      equippedItems.hatId = equip;
    }else if (equip[0] == "a"){
      equippedItems.accessoriesId = equip;
    }else if (equip[0] == "c"){
      equippedItems.clothesId = equip;
    }

    let newTamagotchi = 
     {
      "age": tamagotchi.age,
      "happiness": tamagotchi.happiness,
      "hunger": tamagotchi.hunger,
      "coins": tamagotchi.coins,
      "coin_streak": 0,
      "ratings": tamagotchi.ratings,
      "equipped_items": JSON.stringify(equippedItems),
      "owned_items": tamagotchi.owned_items,
      "daily_coins": tamagotchi.daily_coins,
      "state_changed": tamagotchi.state_changed,
      "last_save": tamagotchi.last_save,
      "nickname": tamagotchi.nickname
     }

    axios({
      url: `${process.env.REACT_APP_API}/tamagotchiRework`,
      method: "post",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
          "age": tamagotchi.age,
          "happiness": tamagotchi.happiness,
          "hunger": tamagotchi.hunger,
          "coins": tamagotchi.coins,
          "coin_streak": 0,
          "ratings": tamagotchi.ratings,
          "equipped_items": JSON.stringify(equippedItems),
          "owned_items": tamagotchi.owned_items,
          "daily_coins": tamagotchi.daily_coins,
          "state_changed": tamagotchi.state_changed,
          "last_save": tamagotchi.last_save,
          "nickname": tamagotchi.nickname,
      }
  }).then(setTamagotchi(newTamagotchi));
  }

  async function BuyItem(newEquipment, price){
  
    console.log("Buying Item: " + newEquipment)
    let owned = JSON.parse(tamagotchi.owned_items);
    
    if (tamagotchi.owned_items == null || tamagotchi.owned_items == "{}"){
      owned = new Array();
    }

    //find in list or add as a new one
    let alreadyHasItem = false;
    for (let i = 0; i < owned.length; i++) {
      const element = owned[i];
      if (owned.accessory_key == newEquipment){
        element.quantity ++;
        alreadyHasItem = true;
      }
    }
    if (alreadyHasItem == false){
      let newItem = {
        "accessory_key": newEquipment,
        "quantity": 1
      }
      owned.push(newItem);
    }

    //deduct the cost from your coins
    let coins = tamagotchi.coins;
    coins-=price;
    

    notify();


    let newTamagotchi = 
     {
      "age": tamagotchi.age,
      "happiness": tamagotchi.happiness,
      "hunger": tamagotchi.hunger,
      "coins": coins,
      "coin_streak": 0,
      "ratings": tamagotchi.ratings,
      "equipped_items": tamagotchi.equipped_items,
      "owned_items": JSON.stringify(owned),
      "daily_coins": tamagotchi.daily_coins,
      "state_changed": tamagotchi.state_changed,
      "last_save": tamagotchi.last_save,
      "nickname": tamagotchi.nickname
     }

    axios({
      url: `${process.env.REACT_APP_API}/tamagotchiRework`,
      method: "post",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authState.access_token}`
      },
      data: {
          "age": tamagotchi.age,
          "happiness": tamagotchi.happiness,
          "hunger": tamagotchi.hunger,
          "coins": coins,
          "coin_streak": 0,
          "ratings": tamagotchi.ratings,
          "equipped_items": tamagotchi.equipped_items,
          "owned_items": JSON.stringify(owned),
          "daily_coins": tamagotchi.daily_coins,
          "state_changed": tamagotchi.state_changed,
          "last_save": tamagotchi.last_save,
          "nickname": tamagotchi.nickname,
      }
  }).then(setTamagotchi(newTamagotchi), setOwnedItems(owned));
  }

  

  async function FetchTamagotchi(){

    try {
      (async () => {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/tamagotchi`,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        setTamagotchi(response.data);
        setOwnedItems(JSON.parse(response.data.owned_items));
        console.log("Tamagotchi:");
        console.log(response.data);
      })();
    } catch (e) {
      console.log(e);
    }
  }

  

  useEffect(() => {
    if (tamagotchi == null || tamagotchi == undefined){
      FetchTamagotchi();
    }

  }, [tamagotchi])


  

  

  const variants = {
    open: {
      opacity: 1,
      top: "0",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 2,
        delayChildren: 0.3,
        staggerChildren: 0.05
      }
    },
    closed: {
      opacity: 1,
      top: "-100%",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 2
      }
    }
  };


  useEffect(() => {
    if (tamagotchi != null){
      console.log("pupil tamagotchi");
      console.log(tamagotchi);
      //set coins
      setCoins(tamagotchi.coins);
      let equippedItems = JSON.parse(tamagotchi.equipped_items);
      let clothesId = "c0";
      let hatId = "h0";
      let accessoriesId = "a0";

      console.log(equippedItems);

      if (equippedItems == null || equippedItems == undefined){
        equippedItems = {};
        equippedItems.clothesId = "c0";
        equippedItems.hatId = "h0";
        equippedItems.accessoriesId = "a0";
      }
        console.log(equippedItems);
        clothesId = equippedItems.clothesId == "" ? "c0" : equippedItems.clothesId;
        hatId = equippedItems.hatId == "" ? "h0" : equippedItems.hatId;
        accessoriesId = equippedItems.accessoriesId == "" ? "a0" : equippedItems.accessoriesId;

      // FIXED: Using window.Image to avoid the styled-component name conflict
      const checkPath = (path, fallback) => new Promise(res => {
        const img = new window.Image();
        img.src = path;
        img.onload = () => res(path);
        img.onerror = () => res(fallback);
      });

      async function buildTama() {
        const finalClothes = await checkPath('/cosmetics/clothes/'+clothesId+'.png', '/cosmetics/clothes/c0.png');
        const finalHat = await checkPath('/cosmetics/hats/'+hatId+'.png', '/cosmetics/hats/h0.png');
        const finalAccessories = await checkPath('/cosmetics/accessories/'+accessoriesId+'.png', '/cosmetics/accessories/a0.png');

        mergeImages([finalClothes, finalHat, finalAccessories])
          .then(b64 => setTamaImage(b64))
          .catch(err => console.error("Merge failed", err));
      }

      buildTama();
    }

  }, [tamagotchi])

  useEffect(() => {
    console.log("showing shop: " +showShop)
  }, [showShop])

  function OpenTheShop(value){
    setShowShop(value);
  }
  

  

  return (

    <EmilePage>
      <Scale scaleTo={1720}>
        <YourEmileContainer>
              <img style={{transform: "scale(0.7)"}}src={tamaImage}></img>
              <AnimatePresence>
                <ShopContainer coins={coins} BuyItem={BuyItem} UpdateTamagotchi={UpdateTamagotchi} ownedItems={ownedItems} tamagotchi={tamagotchi} tamaImage={tamaImage} setShowShop={OpenTheShop} variants={variants} style={props} showShop={showShop}>
                </ShopContainer>
              </AnimatePresence>
              <PurpleBar showBar={!showShop} setShowShop={OpenTheShop} showShop={showShop} style={props} />
        </YourEmileContainer>
      </Scale>
        
    
    </EmilePage>
    
  );
}



export function OldYourEmile() {
  return (
    <YourEmileContainer>
      <Scale scaleTo={1420}>
        <body>
          <Gallery>
            <a>
              <Image src={Tama1}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama2}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama3}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama4}></Image>
            </a>
          </Gallery>
        </body>
        <div>
          <h1 style={{ textAlign: "center" }}>To raise your Emile, please download the app.</h1>

          <LinkButton href={process.env.REACT_APP_DOWNLOAD_URL} target="_blank">
            Download App
        </LinkButton>
        </div>
      </Scale>
    </YourEmileContainer>
  );
}


const EmilePage = styled.div`
display: flex;
flex-direction: column;
height: 100%;
width: 100%;
background-image: url(${woods});
ackground-repeat: no-repeat;
background-size: cover;
overflow: hidden;
`

const YourEmileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
  }
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  background-image: url(${woods});
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 10em;
  border-right: 2px solid #79559a;
`;

const Image = styled.img`
width:100%;
height:auto;
`

const Gallery = styled.div`
padding: 0 6px;
  float: left;
  width: 24%;
`

const Button = styled.button`
    font-size: 2em;
    background: rgb(234, 146, 19);
    background: linear-gradient(
        0deg,
        rgba(234, 146, 19, 1) 0%,
        rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    color: #fff;
    user-select: none;
    padding: 0.25em 2.5em;
    margin: 1em 0;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin: 0;
    }
`;
